import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

import { signOut } from "@/lib/auth-client";

/**
 * Sign the user out and drop every cached query, then redirect to /login.
 * Clearing the cache matters: per-user data (my-person, direct reports,
 * announcements) must not leak into the next account signed in on this tab.
 * Shared by the sidebar footer and the topbar user menu.
 */
export function useSignOut() {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useCallback(async () => {
    await signOut();
    queryClient.clear();
    router.navigate({ to: "/login" });
  }, [queryClient, router]);
}
